import React from 'react'
import { useTranslation } from 'react-i18next'
import { Input } from '../ui/Input'
import { Icon } from '../ui/Icon'

interface SearchBoxProps {
  value: string
  onChange: (query: string) => void | Promise<void>
}

export const SearchBox: React.FC<SearchBoxProps> = ({ value, onChange }) => {
  const { t } = useTranslation()

  return (
    <Input
      id="search-docs"
      placeholder={t('sidebar.search')}
      value={value}
      onChange={(e) => onChange(e.target.value)}
      size="sm"
      icon={<Icon name="search" />}
    />
  )
}